import classNames from 'classnames';

export default function SkipToContent() {
    return (
        <a
            href="#main-content"
            className={classNames(
                'sr-only',
                'focus-visible:not-sr-only',
                'focus-visible:absolute',
                'focus-visible:top-4',
                'focus-visible:left-4',
                'focus-visible:z-[9999]',
                'focus-visible:block',
                'bg-black',
                'text-white',
                'px-10',
                'py-5',
                'rounded',
                'shadow-lg'
            )}
        >
            Skip to content
        </a>
    )
}